module.exports={
	"Form": "MaterialCreateManifest",
	"Scope": "Material-Create",
	"Descriptors":
	{
		"MaterialDetails.Name":
		{
			"Name": "Name",
			"Hash": "Material-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Material-Create-Identity",
				"Group": "Material-Create-Identity"
			}
		},
		"MaterialDetails.NameAbbreviated":
		{
			"Name": "Name Abbreviated",
			"Hash": "Material-Create-NameAbbreviated",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Material-Create-Identity",
				"Group": "Material-Create-Identity"
			}
		},
		"MaterialDetails.CatalogCode":
		{
			"Name": "Catalog Code",
			"Hash": "Material-Create-CatalogCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Material-Create-Identity",
				"Group": "Material-Create-Identity"
			}
		},
		"MaterialDetails.MaterialCode":
		{
			"Name": "Material Code",
			"Hash": "Material-Create-MaterialCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Material-Create-Identity",
				"Group": "Material-Create-Identity"
			}
		},
		"MaterialDetails.ItemCode":
		{
			"Name": "Item Code",
			"Hash": "Material-Create-ItemCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Material-Create-Identity",
				"Group": "Material-Create-Identity"
			}
		},
		"MaterialDetails.Type":
		{
			"Name": "Type",
			"Hash": "Material-Create-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Material-Create-Details",
				"Group": "Material-Create-Details"
			}
		},
		"MaterialDetails.Description":
		{
			"Name": "Description",
			"Hash": "Material-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "4",
				"Width": 12,
				"Section": "Material-Create-Details",
				"Group": "Material-Create-Details"
			}
		},
		"MaterialDetails.UnitsMetric":
		{
			"Name": "Units Metric",
			"Hash": "Material-Create-UnitsMetric",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "Material-Create-Details",
				"Group": "Material-Create-Details"
			}
		},
		"MaterialDetails.UnitsImperial":
		{
			"Name": "Units Imperial",
			"Hash": "Material-Create-UnitsImperial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "Material-Create-Details",
				"Group": "Material-Create-Details"
			}
		},
		"MaterialDetails.Active":
		{
			"Name": "Active",
			"Hash": "Material-Create-Active",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Material-Create-Details",
				"Group": "Material-Create-Details"
			}
		},
		"MaterialDetails.BrandNameRequired":
		{
			"Name": "Brand Name Required",
			"Hash": "Material-Create-BrandNameRequired",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "6",
				"Width": 3,
				"Section": "Material-Create-Details",
				"Group": "Material-Create-Details"
			}
		},
		"MaterialDetails.IDMaterialParent":
		{
			"Name": "Parent Material",
			"Hash": "Material-Create-IDMaterialParent",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "6",
				"Width": 4,
				"Section": "Material-Create-Details",
				"Group": "Material-Create-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				]
			}
		},
		"MaterialDetails.Category":
		{
			"Name": "Category",
			"Hash": "Material-Create-Category",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "Material-Create-Details",
				"Group": "Material-Create-Details"
			}
		},
		"MaterialDetails.CategoryName":
		{
			"Name": "Category Name",
			"Hash": "Material-Create-CategoryName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "Material-Create-Details",
				"Group": "Material-Create-Details"
			}
		},
		"MaterialDetails.ItemSection":
		{
			"Name": "Item Section",
			"Hash": "Material-Create-ItemSection",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "Material-Create-Details",
				"Group": "Material-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Material-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Material-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Material-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Material-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
